import { Button } from "components/ui/button";
import { Check, Pencil, X } from "lucide-react";
import { useHomeLayout } from "./home-layout-context";

export const HomeEditActions = () => {
  const { isEditing, startEdit, commit, cancel } = useHomeLayout();

  if (!isEditing) {
    return (
      <Button
        variant="outline"
        size="sm"
        onClick={startEdit}
        data-testid="home-edit"
      >
        <Pencil className="size-4 mr-2" />
        Edit layout
      </Button>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={cancel}
        data-testid="home-cancel"
      >
        <X className="size-4 mr-2" />
        Cancel
      </Button>
      <Button size="sm" onClick={commit} data-testid="home-save">
        <Check className="size-4 mr-2" />
        Save
      </Button>
    </div>
  );
};
